module.exports = __webpack_public_path__ + "media/images/cleaning/karima-5a6b4347108403743d76cf6015988795.jpg";